//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class AttendanceSummaryDisplayItem extends ItemBase {
    StudentID: string | null = null;
    AttendanceRate: number = 0;
    LessonsScheduled: number = 0;
    Unrecorded: number = 0;
    TeacherAbsent: number = 0;
    Absent: number = 0;
    Present: number = 0;
    LessonsAttended: number = 0;     // OBSOLETE - Use only for compatibility
    LessonsMissed: number = 0;     // OBSOLETE - Use only for compatibility

    constructor(initializer?: Partial<AttendanceSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceSummaryDisplayItem";
}
